<template>
    <v-container fluid>
        <div class="modal-padding">
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="center-name text-bold">Reset Password</div>
                </v-col>
                <v-col cols="12" sm="12" class="zero-top">
                    <v-text-field
                        type="password"
                        v-model="newPassword"
                        :label="'New Password for '+ data.name"
                        @keydown.space.prevent
                        dense
                        outlined
						autocomplete="new-password"
                        hide-details
                    ></v-text-field>
                    <InputError :data="error.newPassword" />
                </v-col>
                <v-col cols="12" sm="12" class="zero-top">
                    <v-text-field
                        type="password"
                        v-model="newConfirmPassword"
                        :label="'Retype New Password for '+ data.name"
                        @keydown.space.prevent
                        dense
                        outlined
                        hide-details
                    ></v-text-field>
                    <InputError :data="error.newConfirmPassword" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12">
                    <div class="right-align">
                        <v-btn
                            @click="reqChangePassword"
                            class="right-btn cust-btn"
                            color="primary"
                            >Done</v-btn
                        >
                    </div>
                </v-col>
            </v-row>
        </div>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: "ResetPassword",
    props: ["onClose", "status", "data"],
    data() {
        return {
            newConfirmPassword: null,
            newPassword: null,
            error: {
                newConfirmPassword: {
                    type: null,
                    message: null,
                },
                newPassword: {
                    type: null,
                    message: "Please enter new password",
                },
            },
        };
    },
    computed: {
        isPasswordMatch() {
            return this.newPassword === this.newConfirmPassword;
        },
    },
    methods: {
        ...mapActions({
            resetPasswordByUserId: "userStore/resetPasswordByUserId",
        }),
        reqChangePassword() {
            if (this.validate()) {
                let reqData = {
                    user_id: this.data.id,
                    password: this.newPassword,
                };
                this.resetPasswordByUserId(reqData)
                    .then((response) => {
                        this.loading = false;
                        this.$toasted.success(`Success\nPassword reset successfully.`, {
                            icon: "check_circle",
                        });
                        (this.newPassword = null),
                            (this.newConfirmPassword = null);
                        this.onClose({ status: false });
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            }
        },
        validate() {
            if (!this.newPassword || this.newPassword.trim().length < 1) {
                this.error.newPassword.type = "error";
            }
            if (
                !this.newConfirmPassword ||
                this.newConfirmPassword.trim().length < 1
            ) {
                this.error.newConfirmPassword.type = "error";
                this.error.newConfirmPassword.message =
                    "Please enter confirm password";
            }

            return !(
                this.error.newConfirmPassword.type === "error" ||
                this.error.newPassword.type === "error"
            );
        },
        setPasswordError(val) {
            if (!val || val.length === 0) {
                this.error.newConfirmPassword.type = null;
            } else if (this.isPasswordMatch) {
                this.error.newConfirmPassword.type = "success";
                this.error.newConfirmPassword.message = "Passwords match";
            } else {
                this.error.newConfirmPassword.type = "error";
                this.error.newConfirmPassword.message =
                    "Passwords do not match";
            }
        },
    },
    watch: {
        status(val) {
            (this.newPassword = null), (this.newConfirmPassword = null);
        },
        newPassword(val) {
            if (this.newConfirmPassword && this.newConfirmPassword.length) {
                this.setPasswordError(this.newConfirmPassword);
            }
            this.error.newPassword.type = null;
        },
        newConfirmPassword(val) {
            this.setPasswordError(val);
        },
    },
};
</script>